"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaService", {
    enumerable: true,
    get: function() {
        return MetaService;
    }
});
const _common = require("@nestjs/common");
const _nanoid = require("nanoid");
const _uuid = require("uuid");
const _nocodbsdk = require("nocodb-sdk");
const _cryptojs = /*#__PURE__*/ _interop_require_default(require("crypto-js"));
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc"));
const _timezone = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/timezone"));
const _XcMigrationSourcev0 = /*#__PURE__*/ _interop_require_default(require("~/meta/migrations/XcMigrationSourcev0"));
const _XcMigrationSource = /*#__PURE__*/ _interop_require_default(require("~/meta/migrations/XcMigrationSource"));
const _XcMigrationSourcev2 = /*#__PURE__*/ _interop_require_default(require("~/meta/migrations/XcMigrationSourcev2"));
const _CustomKnex = require("~/db/CustomKnex");
const _ncconfig = require("~/utils/nc-config");
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_timezone.default);
const nanoid = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz_', 4);
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
const nanoidWorkspace = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 7);
let MetaService = class MetaService {
    get knexInstance() {
        return this._knex;
    }
    get config() {
        return this._config;
    }
    get connection() {
        var _this_trx;
        return (_this_trx = this.trx) != null ? _this_trx : this.knexInstance;
    }
    get knexConnection() {
        return this.connection;
    }
    get knex() {
        return this.knexConnection;
    }
    /***
   * Generate nanoid for the given target
   * @param target - Table name
   * @returns {string} - Generated nanoid
   * */ async genNanoid(target) {
        if (target === _globals.MetaTable.AUDIT) {
            return (0, _uuid.v7)();
        }
        const prefixMap = {
            [_globals.MetaTable.PROJECT]: 'p',
            [_globals.MetaTable.SOURCES]: 'b',
            [_globals.MetaTable.MODELS]: 'm',
            [_globals.MetaTable.COLUMNS]: 'c',
            [_globals.MetaTable.COL_RELATIONS]: 'l',
            [_globals.MetaTable.COL_SELECT_OPTIONS]: 's',
            [_globals.MetaTable.COL_LOOKUP]: 'lk',
            [_globals.MetaTable.COL_ROLLUP]: 'rl',
            [_globals.MetaTable.COL_FORMULA]: 'f',
            [_globals.MetaTable.FILTER_EXP]: 'fi',
            [_globals.MetaTable.SORT]: 'so',
            [_globals.MetaTable.SHARED_VIEWS]: 'sv',
            [_globals.MetaTable.ACL]: 'ac',
            [_globals.MetaTable.FORM_VIEW]: 'fv',
            [_globals.MetaTable.FORM_VIEW_COLUMNS]: 'fvc',
            [_globals.MetaTable.GALLERY_VIEW]: 'gv',
            [_globals.MetaTable.GALLERY_VIEW_COLUMNS]: 'gvc',
            [_globals.MetaTable.KANBAN_VIEW]: 'kv',
            [_globals.MetaTable.KANBAN_VIEW_COLUMNS]: 'kvc',
            [_globals.MetaTable.CALENDAR_VIEW]: 'cv',
            [_globals.MetaTable.CALENDAR_VIEW_COLUMNS]: 'cvc',
            [_globals.MetaTable.CALENDAR_VIEW_RANGE]: 'cvr',
            [_globals.MetaTable.USERS]: 'us',
            [_globals.MetaTable.ORGS_OLD]: 'org',
            [_globals.MetaTable.TEAMS]: 'tm',
            [_globals.MetaTable.VIEWS]: 'vw',
            [_globals.MetaTable.HOOKS]: 'hk',
            [_globals.MetaTable.HOOK_LOGS]: 'hkl',
            [_globals.MetaTable.API_TOKENS]: 'tkn',
            [_globals.MetaTable.EXTENSIONS]: 'ext',
            [_globals.MetaTable.COMMENTS]: 'com',
            [_globals.MetaTable.COMMENTS_REACTIONS]: 'cre',
            [_globals.MetaTable.USER_COMMENTS_NOTIFICATIONS_PREFERENCE]: 'cnp',
            [_globals.MetaTable.JOBS]: 'job',
            [_globals.MetaTable.INTEGRATIONS]: 'int',
            [_globals.MetaTable.FILE_REFERENCES]: 'at',
            [_globals.MetaTable.COL_BUTTON]: 'btn',
            [_globals.MetaTable.SNAPSHOT]: 'snap',
            [_globals.MetaTable.SYNC_CONFIGS]: 'sync',
            [_globals.MetaTable.PERMISSIONS]: 'perm',
            [_globals.MetaTable.PERMISSION_SUBJECTS]: 'pers',
            [_globals.MetaTable.DASHBOARDS]: 'dash',
            [_globals.MetaTable.WIDGETS]: 'wgt',
            [_globals.MetaTable.WORKSPACE]: 'w',
            [_globals.MetaTable.LIST_VIEW]: 'lv',
            [_globals.MetaTable.LIST_VIEW_COLUMNS]: 'lvc',
            [_globals.MetaTable.LIST_VIEW_LEVELS]: 'lvl',
            [_globals.MetaTable.DEPENDENCY_TRACKER]: 'dt',
            [_globals.MetaTable.INSTALLATIONS]: 'inst',
            [_globals.MetaTable.AUTOMATIONS]: 'aut',
            [_globals.MetaTable.AUTOMATION_EXECUTIONS]: 'auex',
            [_globals.MetaTable.MANAGED_APPS]: 'ma',
            [_globals.MetaTable.MANAGED_APP_VERSIONS]: 'mav',
            [_globals.MetaTable.MANAGED_APP_DEPLOYMENT_LOGS]: 'madl',
            [_globals.MetaTable.SANDBOXES]: 'sb',
            [_globals.MetaTable.SCIM_CONFIG]: 'scfg',
            [_globals.MetaTable.RLS_POLICIES]: 'rlp',
            [_globals.MetaTable.RLS_POLICY_SUBJECTS]: 'rlps'
        };
        const prefix = prefixMap[target] || 'nc';
        // using nanoid to avoid collision with existing ids when duplicating
        return `${prefix}${target === _globals.MetaTable.WORKSPACE ? nanoidWorkspace() : nanoidv2()}`;
    }
    contextCondition(query, workspace_id, base_id, target) {
        if (workspace_id === base_id) {
            return;
        }
        if (target === _globals.MetaTable.WORKSPACE) {
            return;
        }
        query.where('fk_workspace_id', workspace_id);
        if (base_id === _globals.RootScopes.WORKSPACE) {
            return;
        }
        if (target !== _globals.MetaTable.PROJECT) {
            query.where('base_id', base_id);
        } else {
            query.where('id', base_id);
        }
    }
    /***
   * Insert record into meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param data - Data to be inserted
   * @param ignoreIdGeneration - If true, will not generate id for the record
   */ async metaInsert2(workspace_id, base_id, target, data, ignoreIdGeneration) {
        const insertObj = _extends({}, data, ignoreIdGeneration ? {} : {
            id: (data == null ? void 0 : data.id) || await this.genNanoid(target)
        });
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            insertObj.fk_workspace_id = workspace_id;
            if (!base_id && base_id !== _globals.RootScopes.WORKSPACE) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            if (base_id !== _globals.RootScopes.WORKSPACE) insertObj.base_id = base_id;
        }
        const at = this.now();
        insertObj.created_at = at;
        insertObj.updated_at = at;
        const qb = this.knexConnection(target).insert(insertObj);
        this.logHelper(workspace_id, base_id, target, qb);
        await qb;
        return insertObj;
    }
    /***
   * Insert multiple records into meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param data - Data to be inserted
   * @param ignoreIdGeneration - If true, will not generate id for the record
   */ async bulkMetaInsert(workspace_id, base_id, target, data, ignoreIdGeneration) {
        if (Array.isArray(data) ? !data.length : !data) {
            return [];
        }
        const insertObj = [];
        const at = this.now();
        const commonProps = {
            created_at: at,
            updated_at: at
        };
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            commonProps.fk_workspace_id = workspace_id;
            commonProps.base_id = base_id;
        }
        for (const d of Array.isArray(data) ? data : [
            data
        ]){
            const id = (d == null ? void 0 : d.id) || (ignoreIdGeneration ? null : await this.genNanoid(target));
            const tempObj = _extends({}, d, ignoreIdGeneration ? {} : {
                id
            }, commonProps);
            insertObj.push(tempObj);
        }
        const BATCH_SIZE = this.knexConnection.client.config.client === 'sqlite3' ? 200 : 10000;
        for(let i = 0; i < insertObj.length; i += BATCH_SIZE){
            await this.knexConnection.batchInsert(target, insertObj.slice(i, i + BATCH_SIZE));
        }
        return insertObj;
    }
    /***
   * Update multiple records in meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param data - Data to be updated
   * @param ids - Ids of the records to be updated
   */ async bulkMetaUpdate(workspace_id, base_id, target, data, ids, condition) {
        if (Array.isArray(data) ? !data.length : !data) {
            return [];
        }
        const query = this.knexConnection(target);
        const at = this.now();
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        const updateObj = _extends({}, data, {
            updated_at: at
        });
        if (!condition) {
            query.whereIn('id', ids).update(updateObj);
        } else {
            if (![
                _globals.MetaTable.FILE_REFERENCES
            ].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'This table does not support conditional bulk update',
                    sql: ''
                });
            }
            query.where(condition);
            // Check if a condition is present in the query builder and throw an error if not.
            this.checkConditionPresent(query, 'update');
            query.update(updateObj);
        }
        this.contextCondition(query, workspace_id, base_id, target);
        return query;
    }
    /***
   * Delete meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param idOrCondition - If string, will delete the record with the given id. If object, will delete the record with the given condition.
   * @param xcCondition - Additional nested or complex condition to be added to the query.
   * @param force - If true, will not check if a condition is present in the query builder and will execute the query as is.
   */ async metaDelete(workspace_id, base_id, target, idOrCondition, xcCondition, force = false) {
        const query = this.knexConnection(target);
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id && base_id !== _globals.RootScopes.WORKSPACE) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        if (typeof idOrCondition !== 'object') {
            query.where('id', idOrCondition);
        } else if (idOrCondition) {
            query.where(idOrCondition);
        }
        if (xcCondition) {
            query.condition(xcCondition, {});
        }
        // Check if a condition is present in the query builder and throw an error if not.
        if (!force) {
            this.checkConditionPresent(query, 'delete');
        }
        // Apply context condition
        this.contextCondition(query, workspace_id, base_id, target);
        this.logHelper(workspace_id, base_id, target, query);
        return query.del();
    }
    /***
   * Get single record from meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base alias
   * @param target - Table name
   * @param idOrCondition - If string, will get the record with the given id. If object, will get the record with the given condition.
   * @param fields - Fields to be selected
   */ async metaGet(workspace_id, base_id, target, idOrCondition, fields) {
        return this.metaGet2(workspace_id, base_id, target, idOrCondition, fields);
    }
    /***
   * Get meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param idOrCondition - If string, will get the record with the given id. If object, will get the record with the given condition.
   * @param fields - Fields to be selected
   * @param xcCondition - Additional nested or complex condition to be added to the query.
   */ async metaGet2(workspace_id, base_id, target, idOrCondition, fields, xcCondition) {
        const query = this.knexConnection(target);
        if (xcCondition) {
            query.condition(xcCondition);
        }
        if (fields == null ? void 0 : fields.length) {
            query.select(...fields);
        }
        if (workspace_id === _globals.RootScopes.FULL_BYPASS && base_id === _globals.RootScopes.FULL_BYPASS) {
        // With full bypass, no context condition is applied
        } else if (workspace_id === _globals.RootScopes.BYPASS && base_id === _globals.RootScopes.BYPASS) {
            // bypass is only allowed for v2 bases, so we join the base table to ensure the base is v2
            if (_globals.BaseRelatedMetaTables.includes(target)) {
                query.whereExists(function() {
                    this.select(1).from(`${_globals.MetaTable.PROJECT} as p`).whereRaw('p.id = base_id').andWhere('p.version', _nocodbsdk.BaseVersion.V2);
                });
            }
        } else if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            this.contextCondition(query, workspace_id, base_id, target);
        }
        if (!idOrCondition) {
            this.logHelper(workspace_id, base_id, target, query);
            return null;
        }
        if (typeof idOrCondition !== 'object') {
            query.where('id', idOrCondition);
        } else {
            query.where(idOrCondition);
        }
        this.logHelper(workspace_id, base_id, target, query);
        return query.first();
    }
    /***
   * Get list of meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param args.condition - Condition to be applied
   * @param args.limit - Limit of records
   * @param args.offset - Offset of records
   * @param args.xcCondition - Additional nested or complex condition to be added to the query.
   * @param args.fields - Fields to be selected
   * @param args.orderBy - Order by fields
   * @returns {Promise<any[]>} - List of records
   * */ async metaList2(workspace_id, base_id, target, args) {
        var _args_fields;
        const query = this.knexConnection(target);
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            const r = _globals.RootScopeTables[workspace_id];
            if (!r) {
                console.log('Invalid scope', _globals.RootScopeTables);
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            this.contextCondition(query, workspace_id, base_id, target);
        }
        if (args == null ? void 0 : args.condition) {
            query.where(args.condition);
        }
        if (args == null ? void 0 : args.limit) {
            query.limit(args.limit);
        }
        if (args == null ? void 0 : args.offset) {
            query.offset(args.offset);
        }
        if (args == null ? void 0 : args.xcCondition) {
            query.condition(args.xcCondition);
        }
        if (args == null ? void 0 : args.orderBy) {
            for (const [col, dir] of Object.entries(args.orderBy)){
                query.orderBy(col, dir);
            }
        }
        if (args == null ? void 0 : (_args_fields = args.fields) == null ? void 0 : _args_fields.length) {
            query.select(...args.fields);
        }
        this.logHelper(workspace_id, base_id, target, query);
        return query;
    }
    /***
   * Get count of meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param args.condition - Condition to be applied
   * @param args.xcCondition - Additional nested or complex condition to be added to the query.
   * @param args.aggField - Field to be aggregated
   * @returns {Promise<number>} - Count of records
   * */ async metaCount(workspace_id, base_id, target, args) {
        var _this;
        const query = this.knexConnection(target);
        if (workspace_id === _globals.RootScopes.BYPASS && base_id === _globals.RootScopes.BYPASS) {
        // bypass
        } else if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            this.contextCondition(query, workspace_id, base_id, target);
        }
        if (args == null ? void 0 : args.condition) {
            query.where(args.condition);
        }
        if (args == null ? void 0 : args.xcCondition) {
            query.condition(args.xcCondition);
        }
        query.count((args == null ? void 0 : args.aggField) || 'id', {
            as: 'count'
        }).first();
        this.logHelper(workspace_id, base_id, target, query);
        return +((_this = await query) == null ? void 0 : _this['count']) || 0;
    }
    /***
   * Update meta data
   * @param workspace_id - Workspace id
   * @param base_id - Base id
   * @param target - Table name
   * @param data - Data to be updated
   * @param idOrCondition - If string, will update the record with the given id. If object, will update the record with the given condition.
   * @param xcCondition - Additional nested or complex condition to be added to the query.
   * @param skipUpdatedAt - If true, will not update the updated_at field
   * @param force - If true, will not check if a condition is present in the query builder and will execute the query as is.
   */ async metaUpdate(workspace_id, base_id, target, data, idOrCondition, xcCondition, skipUpdatedAt = false, force = false, allowCreatedAt = false) {
        const query = this.knexConnection(target);
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        if (!allowCreatedAt) {
            delete data.created_at;
        }
        if (!skipUpdatedAt) {
            data.updated_at = this.now();
        }
        query.update(data);
        if (typeof idOrCondition !== 'object') {
            query.where('id', idOrCondition);
        } else if (idOrCondition) {
            query.where(idOrCondition);
        }
        if (xcCondition) {
            query.condition(xcCondition);
        }
        // Check if a condition is present in the query builder and throw an error if not.
        if (!force) {
            this.checkConditionPresent(query, 'update');
        }
        // Apply context condition
        this.contextCondition(query, workspace_id, base_id, target);
        this.logHelper(workspace_id, base_id, target, query);
        return await query;
    }
    /***
   * Get order value for the next record
   * @param target - Table name
   * @param condition - Condition to be applied
   * @param xcCondition - Additional nested or complex condition to be added to the query.
   * @returns {Promise<number>} - Order value
   * */ async metaGetNextOrder(target, condition, xcCondition) {
        var _this;
        const query = this.knexConnection(target);
        if (condition) {
            query.where(condition);
        }
        if (xcCondition) {
            query.condition(xcCondition);
        }
        query.max('order', {
            as: 'order'
        });
        return (+((_this = await query.first()) == null ? void 0 : _this.order) || 0) + 1;
    }
    async logHelper(workspace_id, base_id, target, q) {
        const qStr = q.toQuery();
        if (workspace_id === _globals.RootScopes.BYPASS && base_id === _globals.RootScopes.BYPASS || workspace_id === _globals.RootScopes.FULL_BYPASS && base_id === _globals.RootScopes.FULL_BYPASS) {
            return;
        }
        if (target === _globals.MetaTable.PROJECT) {
            if (!qStr.includes('fk_workspace_id') || !qStr.includes('id')) {
                if (!(workspace_id in _globals.RootScopeTables)) {
                    console.log(`Missing tenant isolation (${workspace_id}): ${qStr}`);
                    console.log(new Error().stack);
                }
            }
        } else {
            if (!qStr.includes('fk_workspace_id') || base_id !== _globals.RootScopes.WORKSPACE && !qStr.includes('base_id')) {
                if (!(workspace_id in _globals.RootScopeTables)) {
                    console.log(`Missing tenant isolation (${workspace_id}): ${qStr}`);
                    console.log(new Error().stack);
                }
            }
        }
    }
    async commit() {
        if (this.trx && this.nested === 0) {
            await this.trx.commit();
            this.trx = null;
        }
    }
    async rollback(e) {
        if (this.trx) {
            await this.trx.rollback(e);
        }
        this.trx = null;
    }
    async startTransaction() {
        const trx = this.connection.isTransaction ? this.connection : await this.connection.transaction();
        // todo: tobe done
        return new MetaService(this.config, trx, // we need to keep track of the nested transaction level
        this.connection.isTransaction ? this.nested + 1 : 0);
    }
    /***
   * Get base list with decrypted config
   * @returns {Promise<any[]>} - List of bases
   * */ async legacyProjectList() {
        // check if table exists
        const tableExists = await this.knexConnection.schema.hasTable('nc_projects');
        if (!tableExists) {
            return [];
        }
        return (await this.knexConnection('nc_projects').select()).map((p)=>{
            p.config = _cryptojs.default.AES.decrypt(p.config, 'secret').toString(_cryptojs.default.enc.Utf8);
            return p;
        });
    }
    getNanoId() {
        return nanoid();
    }
    isMySQL() {
        return this.connection.clientType() === 'mysql' || this.connection.clientType() === 'mysql2';
    }
    now() {
        return (0, _dayjs.default)().utc().format(this.isMySQL() ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm:ssZ');
    }
    formatDateTime(date) {
        return (0, _dayjs.default)(date).utc().format(this.isMySQL() ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm:ssZ');
    }
    async init() {
        // skip migration in worker container
        if (_utils.isWorker) {
            return true;
        }
        /*
      if xc_knex_migrations table exists, then run the migrations (Existing installations)
      if xc_knex_migrations table does not exist, then run the migrations (Fresh installations)

      Soon we will have a version where we will remove old migrations
      So users will have to upgrade to specific version first and then to the latest version
    */ if (await this.connection.schema.hasTable('xc_knex_migrations')) {
            // see if there are records in the v1 migration table
            const records = await this.connection('xc_knex_migrations').select('*').limit(1);
            if (records.length > 0) {
                await this.connection.migrate.latest({
                    migrationSource: new _XcMigrationSource.default(),
                    tableName: 'xc_knex_migrations'
                });
                await this.connection.migrate.latest({
                    migrationSource: new _XcMigrationSourcev2.default(),
                    tableName: 'xc_knex_migrationsv2'
                });
            }
        }
        await this.connection.migrate.latest({
            migrationSource: new _XcMigrationSourcev0.default(),
            tableName: 'xc_knex_migrationsv0'
        });
        return true;
    }
    /**
   * Checks if a condition is present in the query builder and throws an error if not.
   *
   * @param queryBuilder - The Knex QueryBuilder instance to check.
   */ checkConditionPresent(queryBuilder, operation) {
        // Convert the query builder to a SQL string to inspect the presence of a WHERE clause.
        const sql = queryBuilder.toString();
        // Ensure that a WHERE condition is present in the query builder.
        // Note: The `hasWhere` method alone is not sufficient since it can indicate an empty nested WHERE group.
        // Therefore, also check the SQL string for the presence of the 'WHERE' keyword.
        if (queryBuilder.hasWhere() && /\bWHERE\b/i.test(sql)) {
            return;
        }
        // Throw an error if no condition is found in the query builder.
        _catchError.NcError.metaError({
            message: 'A condition is required to ' + operation + ' records.',
            sql
        });
    }
    constructor(config, trx = null, nested = 0){
        this._config = config;
        this._knex = (0, _CustomKnex.XKnex)(_extends({}, this._config.meta.db, {
            useNullAsDefault: true
        }));
        this.trx = trx;
        this.nested = nested;
    }
};
MetaService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(1, (0, _common.Optional)()),
    _ts_param(2, (0, _common.Optional)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _ncconfig.NcConfig === "undefined" ? Object : _ncconfig.NcConfig,
        void 0,
        void 0
    ])
], MetaService);
